import React, { useEffect, useState } from 'react';
import {GetCurrentLanguage, HandleChangeLang} from '../util/ChangeLanguage';
import '../assets/css/dropdown.css';
import uk from '../assets/img/uk.svg';
import vietnam from '../assets/img/vn.svg';
import { Trans } from '@lingui/macro';
import {useQuery} from "../common/hooks/useQuery";
const ChangeLang = () => {
  var curLang = GetCurrentLanguage();
  const query = useQuery()
  const langQuery = query.get("lang")
  const [lang, setLang] = useState(curLang);
  useEffect(() => {
    if (langQuery){
      setLang(langQuery)
    } else {
      setLang(curLang)
    }
  }, [langQuery]);

  useEffect(() => {
    if (lang){
      HandleChangeLang(lang)
    }
  },[lang])

  return (
    <div>
      <div className=" relative inline-block text-left dropdown">
        <span className="rounded-md">
          <button
            className="inline-flex items-center justify-center w-full px-4 py-2 text-sm font-medium leading-5 text-gray-700 transition duration-150 ease-in-out bg-transparent  rounded-md active:text-gray-800"
            type="button"
            aria-haspopup="true"
            aria-expanded="true"
          >
            <img src={lang == '' ? uk : lang == 'vi-VN' ? vietnam : uk} />
          </button>
        </span>
        <div className="opacity-0 invisible dropdown-menu transition-all duration-300 transform origin-top-right -translate-y-2 scale-95">
          <div
            className="absolute w-36 right-0 mt-2 origin-top-right bg-white border-gray-200 divide-y divide-gray-100 shadow-lg outline-none"
            role="menu"
          >
            <div
              className="flex justify-between items-center cursor-pointer hover:bg-[#C9E4F3]"
              onClick={() => setLang('vi-VN')}
            >
              {lang === "en-US" ?
                (<div className="flex w-full justify-between px-2 py-1">
                  <img src={vietnam}/>
                  <div className="mx-2 my-auto">
                    <Trans>Tiếng Việt</Trans>
                  </div>
                </div>)
                : (<div className="flex w-full justify-between px-2 py-1 bg-[#C9E4F3]">

                  <img src={vietnam}/>
                  <div className="mx-2 my-auto">
                    <Trans>Tiếng Việt</Trans>
                  </div>
                </div>)}
            </div>
            <div
              className="flex justify-between items-center cursor-pointer hover:bg-[#C9E4F3]"
              onClick={() => setLang('en-US')}
            >
              {lang === "vi-VN" ?
                (<div className="flex w-full justify-between px-2 py-1">
                  <img src={uk}/>
                  <div className="mx-2 m-auto">
                    <Trans>Tiếng Anh</Trans>
                  </div>
                </div>)
                : (<div className="flex w-full justify-between pl-2 py-1 pr-1 bg-[#C9E4F3]">
                  <img src={uk}/>
                  <div className="mx-2 m-auto">
                    <Trans>Tiếng Anh</Trans>
                  </div>

                </div>)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangeLang;
